import { Link, type LinkProps } from 'react-router-dom'
import styled from 'styled-components'

interface BaseLinkProps extends LinkProps {
  id: string
}

const StyledLink = styled(Link).attrs({
  className: 'pointer',
})`
  text-decoration: none;
  outline: none;

  @media (hover: hover) {
    &:hover {
      text-decoration: none;
    }
  }
`

export function BaseLink({ children, ...props }: BaseLinkProps) {
  return <StyledLink {...props}>{children}</StyledLink>
}
